import { observable } from 'mobx';
import type { ShinkansenSeatType } from './traveler_information';

export type GradeResponseArgs = {
  id: number;
  name: string;
  shinkansen_seat_type?: string | null;
};

export type GradeArgs = {
  id: number;
  name: string;
  shinkansenSeatTypes: ShinkansenSeatType[];
};

export const convertGradeResponseToArgs = (response: GradeResponseArgs) => {
  const shinkansenSeatTypes = response.shinkansen_seat_type
    ? (response.shinkansen_seat_type.split(',') as ShinkansenSeatType[])
    : [];
  const args: GradeArgs = {
    id: response.id,
    name: response.name,
    shinkansenSeatTypes
  };
  return args;
};

export default class Grade {
  @observable id: number;
  @observable name: string;
  @observable shinkansenSeatTypes: ShinkansenSeatType[];

  constructor(args: GradeArgs) {
    this.id = args.id;
    this.name = args.name;
    this.shinkansenSeatTypes = args.shinkansenSeatTypes;
  }
}
